import { formatBigNumber } from './constants';
import { ColorType } from 'highcharts';

export const GWP_CHART_OPTIOINS = (name: string, value: number, unit: string, colors?: string[]) => ({
  chart: {
    type: 'pie',
    animation: true,
    marginBottom: 80,
    spacingTop: 5,
    spacingBottom: 40,
    marginTop: 10,
    reflow: true,
    height: "60%",
  },
  xAxis: {
    visible: false,
    lineWidth: 0,
    labels: { enabled: false },
    gridLineWidth: 0,
    tickWidth: 0,
  },
  yAxis: {
    visible: false,
    lineWidth: 0,
    labels: { enabled: false },
    gridLineWidth: 0,
    tickWidth: 0,
  },
  title: {
    text: '',
    margin: 5,
  },
  credits: {
    enabled: false,
  },
  subtitle: {
    text: `<div class="chart-inner-text" style="">
              <span id="subtitle-text" class="text">${name}</span>
              <span id="subtitle-value" class="value">${formatBigNumber(value)}</span>
              <span id="subtitle-unit" class="unit">${unit}</span>
           </div>`,
    useHTML: true,
    align: 'center',
    verticalAlign: 'middle',
    y: 0,
    style: {
      fontSize: '16px',
      color: '#547080',
    },
  },
  legend: {
    ...gwpLegendProperties(),
    labelFormatter:function(this: any) {
       return gwpGetCustomLegend(this.color, this.name, `${this.y} ${unit}`);
    },
  },
  plotOptions: {
    pie: {
      innerSize: '78%',
      dataLabels: {
        enabled: false,
      },
      borderWidth: 8,
      borderColor: '#ffffff',
      showInLegend: true,
    },
  },
  colors: colors,
  tooltip: {
    enabled: false,
  },
  series: [],
  accessibility: { enabled: false },
}) as Highcharts.Options;

export const HOTSPOT_CHART_OPTIOINS = (name: string, value: number, unit: string, colors?: string[]) => ({
  chart: {
    type: 'pie',
    animation: true,
    marginBottom: 80,
    spacingTop: 5,
    spacingBottom: 40,
    marginTop: 10,
    reflow: true,
    height: "60%",
  },
  xAxis: {
    visible: false,
    lineWidth: 0,
    labels: { enabled: false },
    gridLineWidth: 0,
    tickWidth: 0,
  },
  yAxis: {
    visible: false,
    lineWidth: 0,
    labels: { enabled: false },
    gridLineWidth: 0,
    tickWidth: 0,
  },
  title: {
    text: '',
    margin: 5,
  },
  credits: {
    enabled: false,
  },
  legend: {
    ...gwpLegendProperties(),
    labelFormatter:function(this: any) {
       return gwpGetCustomLegend(this.color, this.name, `${this.y} ${unit}`);
    },
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: false,
      },
      borderWidth:3,
      borderColor: '#ffffff',
      showInLegend: true,
    },
  },
  colors: colors,
  tooltip: {
    enabled: false,
  },
  series: [],
  accessibility: { enabled: false },
}) as Highcharts.Options;

export const SCENARIO_ANALYSIS:  Highcharts.Options = {

  credits: {
    enabled: false
  },
  chart: {
    type: 'column',
    spacing: [20, 20, 32, 20],
    className:'score-barchart-section',
  },

  title: {
    text: '',
    align: 'left',
    style: {
      fontFamily: 'Roboto',
      fontSize:'18px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '26px',
    }
  },
  subtitle: {
    text: '',
    align: 'left',
    style: {
      fontFamily: 'Roboto',
      fontSize:'14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '20px'
    }
  },
  yAxis: {
    tickInterval: 1,
    min: 0,
    gridLineDashStyle: "Dot",
    title: {
      text: 'PEF points (pt)'
    }
  },
  tooltip: {
    pointFormat: '<span>{series.name}: <b>{point.y}</b><br/></span>',
    style: {
      color: 'white',
      fontSize: '13',
      whiteSpace: 'normal'

    },
    padding: 10,
    backgroundColor: '#42454B',
    shadow: false,
    borderColor: '#42454B',
    borderRadius: 5,
    outside: false
  },
  legend: {
    className:'score-analysis-legends',
    align: 'right',
    verticalAlign: 'bottom',
    layout: 'vertical',
    symbolWidth: 12,
    symbolHeight: 12,
    symbolRadius: 0,
    itemMarginTop: 12,
    itemStyle:{
      fontFamily: 'Roboto',
      fontSize:'12px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '20px'
    }
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      pointPadding: 0.1,
      borderWidth: 0
    },
    series: {
      dataLabels: {
        enabled: false, // Enables data labels
        align: 'center', // Aligns labels to the right of the bars
        color: '#42454B', // Sets the text color
        style: {
          fontSize: '18px' // Sets the font size
        },
        format: '{y}' // Template for the label text, where {y} represents the data value
      }
    }
  },
  series: [],
  lang: {
    noData: 'No data is available in the chart'
  },
  noData: {
    style: {
      fontFamily: 'Roboto',
      fontSize:'18px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '26px',
    }
  }
}

const gwpGetCustomLegend = (
  color: ColorType,
  name: string,
  legendValue: any,
): string => {
  return `
  <div style="font-family: Roboto; width: 100%; display: flex; align-items: baseline;">
    <span style="width: 10px; height: 10px; background-color: ${color}; display: inline-block; margin-right: 5px; flex-shrink: 0; border:1px solid rgba(0,0,0,.10)"></span>
    <span style="min-width: 0;font-weight:400;  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
      ${name}
    </span>
    <span style="border-bottom: 1px dotted #CAD0D3; flex-grow: 1; height: 2px; margin: 0 10px;"></span>
    <span style="white-space: nowrap;flex-shrink: 0; font-weight:400;">
      ${legendValue}
    </span>
  </div>`;
};

const gwpLegendProperties = (): Highcharts.LegendOptions => {
  return {
    useHTML: true,
    floating: true,
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'vertical',
    symbolRadius: 0,
    itemMarginTop: 2,
    itemMarginBottom: 2,
    itemWidth: null,
    className:'legend-bullet',
    navigation: {
      enabled: false,
    },
    y: 50, // Moves legend down
    margin: 5, // Adds space betw
    enabled: true,
    symbolHeight: 0,
    symbolWidth: 0,
    symbolPadding: 0,
    x:-4,
    width: '100%', // or try fixed value like 200
    itemStyle: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12px",
      whiteSpace: "nowrap",
      overflow: "visible",
    },
  };
};

